/**
 * Période d'une lettre mensuelle, en toutes lettres : « Décembre 2025 ».
 *
 * Écrit ici plutôt que dans chaque page : la rubrique et le détail l'affichaient
 * chacun avec leur propre fonction, et la première capitale manquait aux deux.
 * Deux copies auraient divergé à la première retouche.
 *
 * La capitale initiale n'est pas une coquetterie : `toLocaleDateString` rend le
 * mois en minuscules, et « décembre 2025 » en tête d'une carte ou d'un fil
 * d'Ariane se lit comme une phrase interrompue plutôt que comme un titre.
 */
export function periodeLisible(year: number, month: number): string {
  const texte = new Date(year, month - 1, 1).toLocaleDateString('fr-FR', {
    month: 'long',
    year: 'numeric',
  })

  return texte.charAt(0).toUpperCase() + texte.slice(1)
}
